var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	36831: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(4219), __webpack_require__.e(1817), __webpack_require__.e(2260), __webpack_require__.e(2076), __webpack_require__.e(7580)]).then(() => (() => (__webpack_require__(/*! @angular/core */ 37580))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	36930: {
		fallback: () => (__webpack_require__.e(184).then(() => (() => (__webpack_require__(/*! @ag-grid-community/core */ 60184))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^32.3.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ag-grid-community/core",

	},
	48196: {
		fallback: () => (Promise.all([__webpack_require__.e(4398), __webpack_require__.e(7141), __webpack_require__.e(8219)]).then(() => (() => (__webpack_require__(/*! rxjs/operators */ 98219))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.8.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	61528: {
		fallback: () => (Promise.all([__webpack_require__.e(4398), __webpack_require__.e(7141), __webpack_require__.e(845)]).then(() => (() => (__webpack_require__(/*! rxjs */ 80845))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^7.8.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	4417: {
		fallback: () => (Promise.all([__webpack_require__.e(6831), __webpack_require__.e(1528), __webpack_require__.e(316)]).then(() => (() => (__webpack_require__(/*! @angular/common */ 60316))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	56484: {
		fallback: () => (Promise.all([__webpack_require__.e(4417), __webpack_require__.e(9689), __webpack_require__.e(8547), __webpack_require__.e(436)]).then(() => (() => (__webpack_require__(/*! @angular/platform-browser */ 80436))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	4219: {
		fallback: () => (Promise.all([__webpack_require__.e(1817), __webpack_require__.e(2076), __webpack_require__.e(6699)]).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/signals */ 36699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	41887: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/core/primitives/di */ 8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	99689: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(6443)]).then(() => (() => (__webpack_require__(/*! @angular/common/http */ 46443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	49488: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(9728), __webpack_require__.e(4417), __webpack_require__.e(9712), __webpack_require__.e(8767), __webpack_require__.e(8465), __webpack_require__.e(8212), __webpack_require__.e(6484), __webpack_require__.e(9689), __webpack_require__.e(2715)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/icon */ 42715))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/icon",

	},
	48767: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(4219), __webpack_require__.e(1817), __webpack_require__.e(2260), __webpack_require__.e(9074)]).then(() => (() => (__webpack_require__(/*! @angular/core/rxjs-interop */ 49074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	85555: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(4417), __webpack_require__.e(4456)]).then(() => (() => (__webpack_require__(/*! @angular/forms */ 34456))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/forms",

	},
	66696: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(9712), __webpack_require__.e(8767), __webpack_require__.e(4398), __webpack_require__.e(5584), __webpack_require__.e(2644), __webpack_require__.e(502), __webpack_require__.e(230), __webpack_require__.e(6104)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/button */ 56104))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/button",

	},
	7352: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(9712), __webpack_require__.e(238), __webpack_require__.e(4398), __webpack_require__.e(877), __webpack_require__.e(7954), __webpack_require__.e(1621), __webpack_require__.e(9123), __webpack_require__.e(8212), __webpack_require__.e(5610), __webpack_require__.e(3168), __webpack_require__.e(277), __webpack_require__.e(2972), __webpack_require__.e(7440), __webpack_require__.e(4652), __webpack_require__.e(3740)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/tabs */ 43740))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/tabs",

	},
	57512: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(4417), __webpack_require__.e(9712), __webpack_require__.e(8767), __webpack_require__.e(238), __webpack_require__.e(877), __webpack_require__.e(7954), __webpack_require__.e(8465), __webpack_require__.e(9698), __webpack_require__.e(390), __webpack_require__.e(8573)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/tooltip */ 28573))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/tooltip",

	},
	43168: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(9488), __webpack_require__.e(4417), __webpack_require__.e(238), __webpack_require__.e(877), __webpack_require__.e(7954), __webpack_require__.e(8465), __webpack_require__.e(9698), __webpack_require__.e(277), __webpack_require__.e(6993)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/menu */ 66993))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/menu",

	},
	7440: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(9712), __webpack_require__.e(4398), __webpack_require__.e(877), __webpack_require__.e(7954), __webpack_require__.e(8465), __webpack_require__.e(1621), __webpack_require__.e(9698), __webpack_require__.e(1559), __webpack_require__.e(8967)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/dropdown */ 98967))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/dropdown",

	},
	56128: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(9712), __webpack_require__.e(238), __webpack_require__.e(4398), __webpack_require__.e(7954), __webpack_require__.e(2817)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/collapse */ 32817))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/collapse",

	},
	4595: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(8503)]).then(() => (() => (__webpack_require__(/*! @ngx-translate/core */ 48503))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^17.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ngx-translate/core",

	},
	11808: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(9488), __webpack_require__.e(8767), __webpack_require__.e(5555), __webpack_require__.e(6696), __webpack_require__.e(877), __webpack_require__.e(5244), __webpack_require__.e(7840), __webpack_require__.e(2644), __webpack_require__.e(502), __webpack_require__.e(7352), __webpack_require__.e(9136), __webpack_require__.e(6512), __webpack_require__.e(1559), __webpack_require__.e(2568), __webpack_require__.e(7828), __webpack_require__.e(9689), __webpack_require__.e(7512), __webpack_require__.e(3168), __webpack_require__.e(277), __webpack_require__.e(7440), __webpack_require__.e(2648), __webpack_require__.e(5744), __webpack_require__.e(5338), __webpack_require__.e(2490), __webpack_require__.e(400), __webpack_require__.e(701), __webpack_require__.e(5245), __webpack_require__.e(3973), __webpack_require__.e(8594), __webpack_require__.e(6220), __webpack_require__.e(9346), __webpack_require__.e(8184), __webpack_require__.e(6930), __webpack_require__.e(3677)]).then(() => (() => (__webpack_require__(/*! @mmi/mmi-ui-core */ 23677))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0-beta.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mmi/mmi-ui-core",

	},
	5531: {
		fallback: () => (__webpack_require__.e(7172).then(() => (() => (__webpack_require__(/*! @angular/animations */ 47172))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations",

	},
	24076: {
		fallback: () => (Promise.all([__webpack_require__.e(9488), __webpack_require__.e(6696), __webpack_require__.e(7840), __webpack_require__.e(6484), __webpack_require__.e(7828), __webpack_require__.e(8672), __webpack_require__.e(8594), __webpack_require__.e(4957), __webpack_require__.e(9399)]).then(() => (() => (__webpack_require__(/*! @mmi/mmi-ops-center-ui-core */ 19399))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mmi/mmi-ops-center-ui-core",

	},
	512: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(6484), __webpack_require__.e(9689), __webpack_require__.e(8329)]).then(() => (() => (__webpack_require__(/*! ngx-markdown */ 8329))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ngx-markdown",

	},
	45244: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(9488), __webpack_require__.e(9712), __webpack_require__.e(238), __webpack_require__.e(4398), __webpack_require__.e(7954), __webpack_require__.e(5584), __webpack_require__.e(6512), __webpack_require__.e(5744), __webpack_require__.e(1034)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/form */ 41034))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/form",

	},
	17840: {
		fallback: () => (Promise.all([__webpack_require__.e(238), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/divider */ 83987))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/divider",

	},
	52644: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/transition-patch */ 76902))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/transition-patch",

	},
	90502: {
		fallback: () => (Promise.all([__webpack_require__.e(8465), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/wave */ 69741))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/wave",

	},
	99136: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(9712), __webpack_require__.e(238), __webpack_require__.e(4398), __webpack_require__.e(877), __webpack_require__.e(7954), __webpack_require__.e(1621), __webpack_require__.e(9123), __webpack_require__.e(9698), __webpack_require__.e(1559), __webpack_require__.e(1791)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/drawer */ 31791))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/drawer",

	},
	82568: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(591), __webpack_require__.e(4417), __webpack_require__.e(9712), __webpack_require__.e(8767), __webpack_require__.e(4398), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/spin */ 66568))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/spin",

	},
	67828: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(591), __webpack_require__.e(8767), __webpack_require__.e(238), __webpack_require__.e(2568), __webpack_require__.e(2648), __webpack_require__.e(5744), __webpack_require__.e(8372)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/list */ 58372))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/list",

	},
	20277: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(6484), __webpack_require__.e(5072)]).then(() => (() => (__webpack_require__(/*! @angular/router */ 95072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	38672: {
		fallback: () => (Promise.all([__webpack_require__.e(9728), __webpack_require__.e(4197)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/skeleton */ 64197))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/skeleton",

	},
	98596: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(9712), __webpack_require__.e(238), __webpack_require__.e(877), __webpack_require__.e(1621), __webpack_require__.e(9123), __webpack_require__.e(8212), __webpack_require__.e(9698), __webpack_require__.e(6512), __webpack_require__.e(5610), __webpack_require__.e(1559), __webpack_require__.e(701), __webpack_require__.e(1663)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/modal */ 51663))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/modal",

	},
	69384: {
		fallback: () => (Promise.all([__webpack_require__.e(591), __webpack_require__.e(238), __webpack_require__.e(3773)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/timeline */ 33773))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/timeline",

	},
	14957: {
		fallback: () => (Promise.all([__webpack_require__.e(277), __webpack_require__.e(4682), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! @mmi/mmi-ops-center-ui-auth */ 9039))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mmi/mmi-ops-center-ui-auth",

	},
	3424: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(9728), __webpack_require__.e(9712), __webpack_require__.e(8465), __webpack_require__.e(8212), __webpack_require__.e(6147)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/code-editor */ 16147))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/code-editor",

	},
	22283: {
		fallback: () => (Promise.all([__webpack_require__.e(9488), __webpack_require__.e(5555), __webpack_require__.e(6696), __webpack_require__.e(7352), __webpack_require__.e(3168), __webpack_require__.e(7440), __webpack_require__.e(6128), __webpack_require__.e(5531), __webpack_require__.e(9249)]).then(() => (() => (__webpack_require__(/*! @chatbot */ 59249))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@chatbot",

	},
	84558: {
		fallback: () => (Promise.all([__webpack_require__.e(9488), __webpack_require__.e(6696), __webpack_require__.e(2644), __webpack_require__.e(502), __webpack_require__.e(2568), __webpack_require__.e(5338), __webpack_require__.e(493)]).then(() => (() => (__webpack_require__(/*! @mmi/mmi-ui-core/elsa */ 20493))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.0-beta.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mmi/mmi-ui-core/elsa",

	},
	84682: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(9689), __webpack_require__.e(9837)]).then(() => (() => (__webpack_require__(/*! keycloak-angular */ 9837))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "keycloak-angular",

	},
	55685: {
		fallback: () => (__webpack_require__.e(2076).then(() => (() => (__webpack_require__(/*! @angular/cdk/clipboard */ 52352))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.13",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/clipboard",

	},
	91030: {
		fallback: () => (Promise.all([__webpack_require__.e(591), __webpack_require__.e(8767), __webpack_require__.e(390), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/tag */ 44376))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/tag",

	},
	71559: {
		fallback: () => (__webpack_require__.e(9168).then(() => (() => (__webpack_require__(/*! @angular/cdk/portal */ 9168))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.13",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/portal",

	},
	85338: {
		fallback: () => (Promise.all([__webpack_require__.e(591), __webpack_require__.e(9712), __webpack_require__.e(8767), __webpack_require__.e(238), __webpack_require__.e(4398), __webpack_require__.e(7954), __webpack_require__.e(3454)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/alert */ 93454))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/alert",

	},
	50877: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(4417), __webpack_require__.e(9975), __webpack_require__.e(9168), __webpack_require__.e(1570)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/overlay */ 81570))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.13",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/overlay",

	},
	6512: {
		fallback: () => (Promise.all([__webpack_require__.e(1528), __webpack_require__.e(4417), __webpack_require__.e(8212), __webpack_require__.e(5245), __webpack_require__.e(7302), __webpack_require__.e(9840)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/i18n */ 29840))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/i18n",

	},
	52648: {
		fallback: () => (Promise.all([__webpack_require__.e(9712), __webpack_require__.e(238), __webpack_require__.e(6512), __webpack_require__.e(1559), __webpack_require__.e(2643)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/empty */ 42643))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/empty",

	},
	25744: {
		fallback: () => (Promise.all([__webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(8465), __webpack_require__.e(1084), __webpack_require__.e(2972), __webpack_require__.e(4483), __webpack_require__.e(904)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/grid */ 50904))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/grid",

	},
	52490: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(238), __webpack_require__.e(6696), __webpack_require__.e(8465), __webpack_require__.e(1621), __webpack_require__.e(9123), __webpack_require__.e(5584), __webpack_require__.e(2644), __webpack_require__.e(502), __webpack_require__.e(230), __webpack_require__.e(1084), __webpack_require__.e(7084)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/input */ 87084))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/input",

	},
	90400: {
		fallback: () => (Promise.all([__webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(9123), __webpack_require__.e(5584), __webpack_require__.e(8824)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/checkbox */ 66443))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/checkbox",

	},
	80701: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(4417), __webpack_require__.e(9975), __webpack_require__.e(854)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/drag-drop */ 50854))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.13",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/drag-drop",

	},
	86220: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(9712), __webpack_require__.e(238), __webpack_require__.e(4398), __webpack_require__.e(5555), __webpack_require__.e(877), __webpack_require__.e(7954), __webpack_require__.e(8465), __webpack_require__.e(1621), __webpack_require__.e(9123), __webpack_require__.e(5584), __webpack_require__.e(9698), __webpack_require__.e(5610), __webpack_require__.e(230), __webpack_require__.e(2648), __webpack_require__.e(6905), __webpack_require__.e(4328)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/select */ 14328))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/select",

	},
	59346: {
		fallback: () => (Promise.all([__webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(9712), __webpack_require__.e(238), __webpack_require__.e(4398), __webpack_require__.e(7954), __webpack_require__.e(8465), __webpack_require__.e(8212), __webpack_require__.e(5584), __webpack_require__.e(9698), __webpack_require__.e(5610), __webpack_require__.e(230), __webpack_require__.e(4870)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/time-picker */ 14870))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/time-picker",

	},
	68184: {
		fallback: () => (Promise.all([__webpack_require__.e(9728), __webpack_require__.e(9712), __webpack_require__.e(238), __webpack_require__.e(877), __webpack_require__.e(1559), __webpack_require__.e(1084), __webpack_require__.e(9917)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/message */ 59917))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/message",

	},
	18642: {
		fallback: () => (__webpack_require__.e(8857).then(() => (() => (__webpack_require__(/*! @ag-grid-community/angular */ 58857))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^32.3.9",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@ag-grid-community/angular",

	},
	72148: {
		fallback: () => (Promise.all([__webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(9712), __webpack_require__.e(238), __webpack_require__.e(4398), __webpack_require__.e(7954), __webpack_require__.e(8465), __webpack_require__.e(1621), __webpack_require__.e(5584), __webpack_require__.e(9698), __webpack_require__.e(230), __webpack_require__.e(7302), __webpack_require__.e(4652), __webpack_require__.e(4535)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/date-picker */ 44535))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/date-picker",

	},
	44272: {
		fallback: () => (Promise.all([__webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(1621), __webpack_require__.e(9123), __webpack_require__.e(5584), __webpack_require__.e(230), __webpack_require__.e(5346)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/input-number */ 15346))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/input-number",

	},
	73780: {
		fallback: () => (Promise.all([__webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(8465), __webpack_require__.e(1084), __webpack_require__.e(5730)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/layout */ 15730))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/layout",

	},
	95323: {
		fallback: () => (Promise.all([__webpack_require__.e(9728), __webpack_require__.e(9712), __webpack_require__.e(238), __webpack_require__.e(1589)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/notification */ 33970))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/notification",

	},
	16240: {
		fallback: () => (Promise.all([__webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(9712), __webpack_require__.e(4398), __webpack_require__.e(1084), __webpack_require__.e(3968)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/pagination */ 83968))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/pagination",

	},
	47776: {
		fallback: () => (Promise.all([__webpack_require__.e(9712), __webpack_require__.e(238), __webpack_require__.e(4398), __webpack_require__.e(7954), __webpack_require__.e(9698), __webpack_require__.e(2839)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/popover */ 92839))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/popover",

	},
	66856: {
		fallback: () => (Promise.all([__webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(9712), __webpack_require__.e(238), __webpack_require__.e(4398), __webpack_require__.e(1621), __webpack_require__.e(9123), __webpack_require__.e(5584), __webpack_require__.e(6411)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/switch */ 78792))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/switch",

	},
	40591: {
		fallback: () => (__webpack_require__.e(1299).then(() => (() => (__webpack_require__(/*! @angular/cdk/bidi */ 63680))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.13",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/bidi",

	},
	99712: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(9728), __webpack_require__.e(8767), __webpack_require__.e(8212), __webpack_require__.e(390), __webpack_require__.e(4219), __webpack_require__.e(5958), __webpack_require__.e(4300)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/config */ 44300))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/config",

	},
	50238: {
		fallback: () => (Promise.all([__webpack_require__.e(9728), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/outlet */ 3317))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/outlet",

	},
	57954: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(5610), __webpack_require__.e(2972), __webpack_require__.e(4796)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/animation */ 94796))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/animation",

	},
	9728: {
		fallback: () => (Promise.all([__webpack_require__.e(6831), __webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(8212), __webpack_require__.e(2972), __webpack_require__.e(6906)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/util */ 66906))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/util",

	},
	85584: {
		fallback: () => (Promise.all([__webpack_require__.e(1528), __webpack_require__.e(9488), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/form */ 10228))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/form",

	},
	90230: {
		fallback: () => (Promise.all([__webpack_require__.e(4417), __webpack_require__.e(9712), __webpack_require__.e(238), __webpack_require__.e(4398), __webpack_require__.e(3378)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/space */ 13378))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/space",

	},
	60591: {
		fallback: () => (Promise.all([__webpack_require__.e(2076), __webpack_require__.e(2973)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/coercion */ 2814))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.13",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/coercion",

	},
	39123: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(4417), __webpack_require__.e(6484), __webpack_require__.e(2102)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/a11y */ 72102))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.13",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/a11y",

	},
	28465: {
		fallback: () => (Promise.all([__webpack_require__.e(4417), __webpack_require__.e(2076), __webpack_require__.e(8402)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/platform */ 17699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.13",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/platform",

	},
	8212: {
		fallback: () => (Promise.all([__webpack_require__.e(6831), __webpack_require__.e(9836), __webpack_require__.e(4658)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/logger */ 24658))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/logger",

	},
	15610: {
		fallback: () => (__webpack_require__.e(8191).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/polyfill */ 58191))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/polyfill",

	},
	50390: {
		fallback: () => (Promise.all([__webpack_require__.e(5958), __webpack_require__.e(7691)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/color */ 7691))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/color",

	},
	59836: {
		fallback: () => (__webpack_require__.e(3444).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/environments */ 23444))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/environments",

	},
	94483: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(4417), __webpack_require__.e(2076), __webpack_require__.e(6057)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/layout */ 87912))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.13",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/layout",

	},
	11621: {
		fallback: () => (__webpack_require__.e(4879).then(() => (() => (__webpack_require__(/*! @angular/cdk/keycodes */ 74879))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.13",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/keycodes",

	},
	89698: {
		fallback: () => (Promise.all([__webpack_require__.e(8767), __webpack_require__.e(1318)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/overlay */ 71318))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/overlay",

	},
	57302: {
		fallback: () => (Promise.all([__webpack_require__.e(9728), __webpack_require__.e(8212), __webpack_require__.e(7221)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/time */ 17221))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/time",

	},
	44652: {
		fallback: () => (Promise.all([__webpack_require__.e(2972), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/cdk/resize-observer */ 2276))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/cdk/resize-observer",

	},
	81084: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(1528), __webpack_require__.e(9728), __webpack_require__.e(8767), __webpack_require__.e(8465), __webpack_require__.e(5610), __webpack_require__.e(4483), __webpack_require__.e(9836), __webpack_require__.e(9062)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/core/services */ 59062))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/core/services",

	},
	44724: {
		fallback: () => (Promise.all([__webpack_require__.e(9728), __webpack_require__.e(9488), __webpack_require__.e(9712), __webpack_require__.e(4398), __webpack_require__.e(7719)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/avatar */ 87719))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/avatar",

	},
	31476: {
		fallback: () => (Promise.all([__webpack_require__.e(6484), __webpack_require__.e(2076)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/pipes */ 72411))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/pipes",

	},
	6905: {
		fallback: () => (Promise.all([__webpack_require__.e(8196), __webpack_require__.e(9975)]).then(() => (() => (__webpack_require__(/*! @angular/cdk/scrolling */ 79975))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.2.13",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/cdk/scrolling",

	},
	49032: {
		fallback: () => (Promise.all([__webpack_require__.e(9728), __webpack_require__.e(591), __webpack_require__.e(9712), __webpack_require__.e(238), __webpack_require__.e(4398), __webpack_require__.e(8393)]).then(() => (() => (__webpack_require__(/*! ng-zorro-antd/progress */ 48393))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^21.3.3",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "ng-zorro-antd/progress",

	},
	88441: {
		fallback: () => (__webpack_require__.e(655).then(() => (() => (__webpack_require__(/*! @angular/animations/browser */ 10655))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "21.2.19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@angular/animations/browser",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"230": [
		90230
	],
	"238": [
		50238
	],
	"277": [
		20277
	],
	"390": [
		50390
	],
	"400": [
		90400
	],
	"502": [
		90502
	],
	"591": [
		40591
	],
	"701": [
		80701
	],
	"877": [
		50877
	],
	"1084": [
		81084
	],
	"1528": [
		61528
	],
	"1559": [
		71559
	],
	"1621": [
		11621
	],
	"1663": [
		31476
	],
	"1808": [
		11808
	],
	"2260": [
		41887
	],
	"2490": [
		52490
	],
	"2568": [
		82568
	],
	"2644": [
		52644
	],
	"2648": [
		52648
	],
	"2972": [
		60591
	],
	"3168": [
		43168
	],
	"3677": [
		18642,
		72148,
		44272,
		73780,
		95323,
		16240,
		47776,
		66856
	],
	"3719": [
		3424
	],
	"3973": [
		98596,
		69384
	],
	"4076": [
		24076
	],
	"4219": [
		4219
	],
	"4417": [
		4417
	],
	"4483": [
		94483
	],
	"4595": [
		4595
	],
	"4652": [
		44652
	],
	"4682": [
		84682
	],
	"4957": [
		14957
	],
	"5244": [
		45244
	],
	"5338": [
		85338
	],
	"5531": [
		5531
	],
	"5555": [
		85555
	],
	"5584": [
		85584
	],
	"5610": [
		15610
	],
	"5744": [
		25744
	],
	"6128": [
		56128
	],
	"6220": [
		86220
	],
	"6484": [
		56484
	],
	"6512": [
		6512
	],
	"6696": [
		66696
	],
	"6831": [
		36831
	],
	"6905": [
		6905
	],
	"6930": [
		36930
	],
	"7302": [
		57302
	],
	"7352": [
		7352
	],
	"7440": [
		7440
	],
	"7512": [
		57512
	],
	"7828": [
		67828
	],
	"7840": [
		17840
	],
	"7954": [
		57954
	],
	"8004": [
		22283,
		84558
	],
	"8184": [
		68184
	],
	"8196": [
		48196
	],
	"8212": [
		8212
	],
	"8372": [
		44724
	],
	"8441": [
		88441
	],
	"8465": [
		28465
	],
	"8594": [
		55685,
		91030
	],
	"8672": [
		38672
	],
	"8767": [
		48767
	],
	"9032": [
		49032
	],
	"9123": [
		39123
	],
	"9136": [
		99136
	],
	"9249": [
		512
	],
	"9346": [
		59346
	],
	"9488": [
		49488
	],
	"9689": [
		99689
	],
	"9698": [
		89698
	],
	"9712": [
		99712
	],
	"9728": [
		9728
	],
	"9836": [
		59836
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}